import { Patient } from './patient.model'
import { Staff } from './staff.model'

export type ExpertiseMeeting = {
  _id: string
  attendees: Pick<Staff, '_id' | 'email' | 'userInfo'>[]
  createdBy: string
  expertise: string
  meetingId: string
  patient: Patient
  pendingAttendees: Pick<Staff, '_id' | 'email' | 'userInfo'>[]
  status: ExpertiseMeetingStatusEnum
  title: string
  timestamp: string
}

enum ExpertiseMeetingStatusEnum {
  SCHEDULED = 'SCHEDULED',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
}

export enum ExpertiseMeetingRequestAccessStatusEnum {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  SENT = 'SENT',
  UNATTEMPTED = 'UNATTEMPTED',
}
